export default __webpack_public_path__ + "static/InterDisplay-SemiBold-6488b25ab11d7dd05b35064728c8b38c.woff2";